export default __webpack_public_path__ + "static/media/ph01.0bc65cdf.png";